import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from "../../../../../Utils/Utils"
import CardCamerasApp from "./CardCamerasApp/CardCamerasApp"

const CamerasAppTab = ({ setOpenCadastro, idCentral }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [camerasList, setCamerasList] = useState(null)
    const [loading, setLoading] = useState(true)

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setLoading(false)
            setCamerasList(msg.data.cameras)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        addRoute("buscarTodasCameras", getDadosIniciais)
        sendWs("buscarTodasCameras", { condId: idCentral })
    }, [])

    return (
        <div style={{ height: '100%', width: '100%' }}>

            {(!loading && camerasList) &&
                camerasList.map((camera, index) => {
                    return (
                        <CardCamerasApp
                            key={index}
                            id={camera.id}
                            index={index}
                            cameraApp={camera}
                            idCentral={idCentral}
                        />
                    )
                })
            }
        </div>
    )
}

export default CamerasAppTab
